import React from 'react';

const CookiePolicy: React.FC = () => {
  return (
    <>
      {/* JSON-LD SEO */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebPage",
            "name": "Cookie Policy - SpinTitanium",
            "description": "SpinTitanium's cookie policy explaining how we use cookies and similar technologies.",
            "url": "https://spintitanium.com/cookie-policy"
          })
        }}
      />

      <div className="min-h-screen bg-titanium-950 pt-20 py-12">
        <div className="container mx-auto px-4 max-w-4xl">
          <h1 className="text-4xl md:text-5xl font-bold mb-8">
            <span className="text-gradient">Cookie Policy</span>
          </h1>
          <p className="text-gray-400 mb-8">Last updated: December 2025</p>

          <div className="glass rounded-xl p-8 border-2 border-titanium-800 space-y-8">
            <section>
              <h2 className="text-2xl font-bold text-white mb-4">1. What Are Cookies?</h2>
              <p className="text-gray-300 leading-relaxed mb-4">
                Cookies are small text files that are placed on your device when you visit a website. They 
                are widely used to make websites work more efficiently and provide information to website owners.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">2. How We Use Cookies</h2>
              <p className="text-gray-300 leading-relaxed mb-4">
                SpinTitanium uses cookies to:
              </p>
              <ul className="list-disc list-inside text-gray-300 space-y-2 mb-4 ml-4">
                <li>Remember your preferences and settings</li>
                <li>Analyze website traffic and usage patterns</li>
                <li>Improve website functionality and user experience</li>
                <li>Provide personalized content and advertisements</li>
                <li>Track affiliate referrals (when you click links to casinos)</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">3. Types of Cookies We Use</h2>
              
              <h3 className="text-xl font-semibold text-white mb-3">3.1 Essential Cookies</h3>
              <p className="text-gray-300 leading-relaxed mb-4">
                These cookies are necessary for the website to function properly. They enable core functionality 
                such as security, network management, and accessibility.
              </p>

              <h3 className="text-xl font-semibold text-white mb-3">3.2 Analytics Cookies</h3>
              <p className="text-gray-300 leading-relaxed mb-4">
                We use analytics cookies to understand how visitors interact with our website. This helps us 
                improve our content and user experience. These cookies collect information anonymously.
              </p>

              <h3 className="text-xl font-semibold text-white mb-3">3.3 Marketing Cookies</h3>
              <p className="text-gray-300 leading-relaxed mb-4">
                Marketing cookies are used to track visitors across websites to display relevant advertisements. 
                We may use these cookies to show you relevant casino offers and promotions.
              </p>

              <h3 className="text-xl font-semibold text-white mb-3">3.4 Functional Cookies</h3>
              <p className="text-gray-300 leading-relaxed mb-4">
                Functional cookies allow the website to remember choices you make (such as your username, language, 
                or region) and provide enhanced, personalized features.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">4. Third-Party Cookies</h2>
              <p className="text-gray-300 leading-relaxed mb-4">
                In addition to our own cookies, we may also use various third-party cookies to report usage 
                statistics, deliver advertisements, and provide other services. These third parties may include:
              </p>
              <ul className="list-disc list-inside text-gray-300 space-y-2 mb-4 ml-4">
                <li>Google Analytics (website analytics)</li>
                <li>Affiliate tracking networks (to track referrals to casinos)</li>
                <li>Advertising networks (to show relevant ads)</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">5. Managing Cookies</h2>
              <p className="text-gray-300 leading-relaxed mb-4">
                You can control and manage cookies in various ways. Please keep in mind that removing or 
                blocking cookies can impact your user experience and parts of our website may no longer be 
                fully accessible.
              </p>
              <h3 className="text-xl font-semibold text-white mb-3">Browser Settings</h3>
              <p className="text-gray-300 leading-relaxed mb-4">
                Most browsers allow you to refuse or accept cookies. You can also delete cookies that have 
                already been set. The methods for doing so vary from browser to browser. Please refer to 
                your browser's help menu for instructions.
              </p>
              <h3 className="text-xl font-semibold text-white mb-3">Cookie Consent</h3>
              <p className="text-gray-300 leading-relaxed mb-4">
                When you first visit our website, you'll see a cookie consent banner. You can choose to 
                accept all cookies, reject non-essential cookies, or customize your preferences.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">6. Do Not Track Signals</h2>
              <p className="text-gray-300 leading-relaxed mb-4">
                Some browsers include a "Do Not Track" (DNT) feature that signals to websites you visit 
                that you do not want to have your online activity tracked. Currently, there is no standard 
                for how DNT signals should be interpreted. We do not currently respond to DNT browser signals.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">7. Updates to This Policy</h2>
              <p className="text-gray-300 leading-relaxed mb-4">
                We may update this Cookie Policy from time to time to reflect changes in our practices or 
                for other operational, legal, or regulatory reasons. Please review this policy periodically 
                for any changes.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">8. Contact Us</h2>
              <p className="text-gray-300 leading-relaxed mb-4">
                If you have questions about our use of cookies, please contact us at:
              </p>
              <p className="text-gray-300 leading-relaxed">
                Email: privacy@spintitanium.com
              </p>
            </section>
          </div>
        </div>
      </div>
    </>
  );
};

export default CookiePolicy;


